export const DEFAULT_RESUME_URL = 'https://drive.google.com/file/d/1PXL3Q7D7opwUSUMyB_3VeXQX9UjLRyJ4/view?usp=sharing';

export const getResumeUrl = () => {
  return localStorage.getItem("custom_resume_url") || DEFAULT_RESUME_URL;
};

export const resume_URL = getResumeUrl();